var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLevel5 = function SvgLevel5(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 16,
    rx: 8,
    fill: "#E17878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9631 4.3H13.0631V11.043H17.2321V12H11.9631V4.3ZM23.0804 6.17L20.5284 12H19.4504L16.8984 6.17H17.9984L20.0004 10.845L22.0464 6.17H23.0804ZM23.9537 12.066C23.7484 12.066 23.5724 11.9963 23.4257 11.857C23.279 11.7103 23.2057 11.527 23.2057 11.307C23.2057 11.0943 23.279 10.9183 23.4257 10.779C23.5724 10.6323 23.7484 10.559 23.9537 10.559C24.159 10.559 24.3314 10.6287 24.4707 10.768C24.61 10.9073 24.6797 11.087 24.6797 11.307C24.6797 11.527 24.6064 11.7103 24.4597 11.857C24.3204 11.9963 24.1517 12.066 23.9537 12.066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.798 7.193C31.8833 7.193 32.6827 7.40933 33.196 7.842C33.7167 8.27467 33.977 8.854 33.977 9.58C33.977 10.0493 33.8597 10.4783 33.625 10.867C33.3903 11.2483 33.031 11.5563 32.547 11.791C32.0703 12.0183 31.48 12.132 30.776 12.132C30.2333 12.132 29.698 12.0623 29.17 11.923C28.6493 11.7763 28.2057 11.571 27.839 11.307L28.543 9.943C28.8363 10.163 29.1737 10.3353 29.555 10.46C29.9363 10.5773 30.3287 10.636 30.732 10.636C31.1793 10.636 31.5313 10.548 31.788 10.372C32.0447 10.196 32.173 9.95033 32.173 9.635C32.173 9.305 32.0373 9.05567 31.766 8.887C31.502 8.71833 31.04 8.634 30.38 8.634H28.411L28.807 4.3H33.504V5.73H30.292L30.171 7.193H30.798Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLevel5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/level5.ab81ced90f224888f514d6861240cb01.blank.svg";